import axios from 'axios'
import config from '../config'
import Cookies from 'js-cookie'
import {store} from '../index'
import {doLogout} from '../actions/auth'
import {message} from 'antd'

const service = axios.create({
    baseURL: config.BASE_API, // api的base_url
});

service.interceptors.request.use(request => {
    const userToken = Cookies.get('userToken')
    if (userToken) {
        request.headers['token'] = userToken
    }
    return request
});

service.interceptors.response.use(response => response, error => {
    if (error.response && error.response.status === 401) {
        store.dispatch(doLogout())
    }
    if (error.response.data.message) {
        message.error(error.response.data.message)
    }
    return Promise.reject(error)
});

export default service;